export default __webpack_public_path__ + "static/media/icon_searchzero.1e87314c.svg";